export default {
      id: "navigateBefore-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#navigateBefore-usage",
      toString: function () {
        return this.url;
      }
    }